module.exports = __webpack_public_path__ + "img/logo.d0790cc3.png";